import { render, staticRenderFns } from "./AbkFileInput.vue?vue&type=template&id=61ad80e8&"
import script from "./AbkFileInput.vue?vue&type=script&lang=js&"
export * from "./AbkFileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports